import { render } from "./BookedPermits.vue?vue&type=template&id=70fe5b31"
import script from "./BookedPermits.vue?vue&type=script&lang=js"
export * from "./BookedPermits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__